// src/services/userManageService.js

import apiService from "./apiService";

// === CUSTOMERS ===
const getAllCustomers = () => apiService.getAll("backend/customers");


// Toggle enable/disable customer
const toggleCustomerStatus = (id) =>
  apiService.post(`backend/customers/${id}/toggle-status`);

// Create a new customer (admin registration)
const createCustomer = (customerData) =>
  apiService.post("backend/auth/register-user-admin", customerData);

// === EXPORT ===
const userManageService = {
  getAllCustomers,
  toggleCustomerStatus,
  createCustomer,
};

export default userManageService;
